// extracted by mini-css-extract-plugin
module.exports = {"loading":"Spinner_loading__2XsV5","loader":"Spinner_loader__3qpwL","logo":"Spinner_logo__DCnxD","wrapper":"Spinner_wrapper__1L8nk"};